import React from "react";
import PropTypes from "prop-types";
import style from "./cardPill.module.scss";
/*
coppied from varsome-components repo.

Pill:
  -- text is required for Pill component to function.
  -- The props color, backgroundColor, verdict and size are optional.
  -- Usage: <Pill inverted={true} verdict="Tier I" /> <Pill text="To do" color="#FFF" backgroundColor="#000" />
*/

const CardPill = ({
  color,
  backgroundColor,
  verdict,
  text,
  size,
  inverted,
}) => {
  const calcVerdictClass = (value) => {
    let verdictStyle = "";
    const needle = value.replace(/\s/g, "");
    switch (needle) {
      case "TierI":
      case "Pathogenic":
        verdictStyle = "tierI";
        break;
      case "TierII":
      case "LikelyPathogenic":
        verdictStyle = "tierII";
        break;
      case "TierIII":
      case "UncertainSignificance":
        verdictStyle = "tierIII";
        break;
      case "TierIV":
      case "Benign":
        verdictStyle = "tierIV";
        break;
      case "LikelyBenign":
        verdictStyle = "LikelyBenign";
        break;
      default:
        verdictStyle = "tierIII";
        break;
    }
    if (inverted) {
      verdictStyle = style[`${verdictStyle}Inverted`];
    } else {
      verdictStyle = style[`${verdictStyle}`];
    }
    return verdictStyle;
  };

  const calcCustomStyle = () => {
    const cssStyle = {};
    if (color) {
      cssStyle.color = color;
    }
    if (backgroundColor) {
      cssStyle.backgroundColor = backgroundColor;
    }
    return cssStyle;
  };

  const calcSize = (value) => {
    let customSize = "";
    if (value === "small") {
      customSize = style.simplePillSmall;
    } else if (value === "medium") {
      customSize = style.simplePillMedium;
    }
    return customSize;
  };

  return (
    <div
      data-testid="verdict-pill-content"
      title={text || verdict}
      className={`${style.simplePill} ${calcSize(size)} ${
        verdict ? calcVerdictClass(verdict) : ""
      } `}
      style={calcCustomStyle()}
    >
      {text || verdict}
    </div>
  );
};

CardPill.propTypes = {
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  verdict: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.string,
  inverted: PropTypes.bool,
};

CardPill.defaultProps = {
  color: undefined,
  backgroundColor: undefined,
  verdict: undefined,
  text: undefined,
  size: "small",
  inverted: false,
};

export default CardPill;
